import { ComponentHandler } from 'src/app/services/component-services/component-handler';
import { GtinCheckService } from './../../../../services/component-services/gtin-check-service';
import { AuthService } from './../../../../services/auth-service';
import { COLOR_THEME_DARK } from 'src/app/navigation/services/color-theme-service';
import { ColorThemeService } from './../../../../navigation/services/color-theme-service';
import { ComponentCanDeactivate } from './../../../../services/unsaved-changes-guard';
import { DictionaryHandler } from './../../../../model/dictionary';
import { ComponentApiService } from '../../../../data-transfer/services/component-api-service';
import { ComponentCreateUpdateParentComponent } from './../common/component-create-update-parent/component-create-update-parent.component';
import { PackagingComponentTypesEnum } from './../../../../model/packaging-component-types-enum';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, HostListener } from '@angular/core';
import { ComponentTypeService } from 'src/app/navigation/services/component-type-service';
import { ComponentNavigationService } from 'src/app/navigation/services/navigation-services/component-navigation-service';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import { VersionDto } from 'src/app/data-transfer/entities/version-dto';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClosureDto } from 'src/app/data-transfer/entities/component-entities/closure-dto';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { CLOSURE_NAME } from 'src/app/model/components/closure-component';

@Component({
  selector: 'app-create-update-closure',
  templateUrl: './create-update-closure.component.html',
  styleUrls: ['./create-update-closure.component.scss']
})
export class CreateUpdateClosureComponent extends ComponentCreateUpdateParentComponent
  implements OnInit, ComponentCanDeactivate {

  closure!: ClosureDto;

  constructor(
    protected componentHandler: ComponentHandler,
    protected dialog: MatDialog,
    protected spinner: NgxSpinnerService,
    protected componentApiService: ComponentApiService,
    protected navigationService: ComponentNavigationService,
    protected componentTypeService: ComponentTypeService,
    protected dictionaryHandler: DictionaryHandler,
    protected fileApiService: FileApiService,
    protected authService: AuthService,
    protected gtinCheckService: GtinCheckService,
    protected dataExchangeApiService: DataExchangeRequestApiService,
    protected route: ActivatedRoute,
    protected router: Router,
    private formBuilder: FormBuilder,
    private colorThemeService: ColorThemeService,
  ) {
    super(componentHandler, dialog, spinner, componentApiService, navigationService,
      componentTypeService, dictionaryHandler, fileApiService, authService, gtinCheckService,
      dataExchangeApiService, route, router);
  }

  ngOnInit(): void {
    this.callerId = PackagingComponentTypesEnum.Closure;
    this.componentType = this.componentTypeService.getComponentTypeDtoByName(CLOSURE_NAME);
    this.componentSubtypes = this.componentHandler.getComponentSubtypesSelection(this.callerId);

    this.routeDataSubscription = this.route.data.subscribe(data => {
      if (data.component) {
        this.closure = data.component;
        this.historyVersions = [{
          id: data.component.id,
          versionNumber: data.component.version,
          versionName: data.component.versionName,
          creationTimestamp: data.component.creationTimestamp,
          isCurrentVersion: data.component.isCurrentVersion,
          packagingComponentCategoryId: this.callerId
        }];
        this.currentDirectoryId = data.component.directoryId;
        if (this.form) {
          window.location.reload();
          super.initComponent(this.closure, this.route);
        }
      } else if (data.dataExchangeRequest) {
        this.closure = data.dataExchangeRequest.component;
        this.subRequestInfo = data.dataExchangeRequest.subRequestInfo;
        this.historyVersions = [{
          id: data.dataExchangeRequest.component.id,
          versionNumber: data.dataExchangeRequest.component.version,
          versionName: data.dataExchangeRequest.component.versionName,
          creationTimestamp: data.dataExchangeRequest.component.creationTimestamp,
          isCurrentVersion: data.dataExchangeRequest.component.isCurrentVersion,
          packagingComponentCategoryId: this.callerId
        }];
        this.currentDirectoryId = data.dataExchangeRequest.component.directoryId;
        if (this.form) {
          window.location.reload();
          super.initComponent(this.closure, this.route);
        }
      } else {
        this.closure = new ClosureDto();
        this.closure.images = [];
        this.closure.certificates = [];
        this.closure.documents = [];
      }
      if (data.permissions) {
        this.permissions = data.permissions;
      }
      if (data.isDataExchangeSubRequest) {
        this.isDataExchangeSubRequest = true;
        if (!data.permissions) {
          super.fetchComponentPermissions(this.closure.id);
        }
      }
      if (data.changedMaterialIds && data.changedMaterialIds.length > 0) {
        super.setChangedMultiMaterials(this.closure.multiMaterial.subMultiMaterials, data.changedMaterialIds);
      }
      if (data.isInOngoingDataExchange) {
        this.isInOngoingDataExchange = data.isInOngoingDataExchange;
        if (this.isInOngoingDataExchange.length > 0 && this.closure.isCurrentVersion) {
          super.navigateToFirstOngoingExchange(this.closure.id);
          return;
        }
      }
    });

    super.initComponent(this.closure, this.route);
    const closureComponent = this.componentHandler.components[this.callerId];
    this.form = closureComponent.createBaseForm(this.closure, this.formBuilder, this.componentSubtypes, this.isTracked);
    this.form = this.formBuilder.group({
      ...this.form.controls,
      distributionCountries: [this.closure.distributionCountries],
      printingCoverage: [this.closure.printingCoverage != null ? this.closure.printingCoverage * 100 : null,
      [Validators.min(0), Validators.max(100)]]
    });
    this.form.controls.totalWeight.disable();
    super.initGtinCheck();

    this.setUpLockAndHeartbeat(this.closure);
    this.disableFormIfRequired();

    this.themeSubscription = this.colorThemeService.colorThemeSubject.subscribe((nextValue) => {
      this.isDarkTheme = nextValue === COLOR_THEME_DARK;
      this.imageSource = this.componentTypeService.getComponentTypeImage(this.callerId, this.isDarkTheme);
    });
  }

  async onComponentSubmit(materialEdited: boolean) {
    this.materialEdited = materialEdited;
    this.form.markAllAsTouched();
    const closureComponent = this.componentHandler.components[this.callerId];
    this.closure = closureComponent.getSingleComponentFromForm(this.form.getRawValue(), false, this.closure) as ClosureDto;

    super.onSubmit(this.closure);
  }

  async onFinishSubRequest(materialEdited: boolean) {
    if (!super.isFormValidForSubRequest()) { return; }
    this.materialEdited = materialEdited;
    this.form.markAllAsTouched();
    const closureComponent = this.componentHandler.components[this.callerId];
    this.closure = closureComponent.getSingleComponentFromForm(this.form.getRawValue(), false, this.closure) as ClosureDto;
    const subRequestId = +this.route.snapshot.params['id'];
    super.setDataAndUpdateAsSubRequest(
      this.closure,
      subRequestId,
      (id, dto, submit, stayOnPage) => this.dataExchangeApiService.updateSubRequestClosure(id, dto, submit, stayOnPage),
      () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true))
    );
  }

  changeClosureVersionName(event: { historyVersion: VersionDto, newName: string }) {
    super.changeVersionName(event.historyVersion, event.newName, this.closure);
  }

  async releaseComponent() {
    super.releaseComponent(this.closure);
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return (this.form.pristine && !this.filesEdited) || this.isPreview || this.isUserValidator || this.isUserAdmin || this.isHistory;
  }

  handleMaterialChange(materialChange: { accepted: boolean, materialId: number }) {
    if (this.closure.id == null) { return; }
    super.handleMaterialChangeParent(this.closure.id, materialChange.materialId, materialChange.accepted);
  }
}
